// auth_config.js

const config = {
  domain: "dev-cqzyi3q3.us.auth0.com",
  clientId: "gXc8NsyPWZI3VftRXQS4JeirpzsvLN8M"
};

export default config;
